var path = '/pages/dashboard/directives/dashboard-sex-directive.tpl.html';
var html = "<canvas class=\"chart chart-doughnut\" chart-data=\"sexCtrl.data\" chart-labels=\"sexCtrl.labels\" height=\"200\"></canvas>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/dashboard/directives/dashboard-sex-directive.tpl.html
// module id = 2238
// module chunks = 1